import { gql } from "@apollo/client";

export const CREATE_CONSENT = gql`
  mutation createConsent($agreementId: String!, $viewedTimestamp: DateTime) {
    createConsent(input: { agreementId: $agreementId, viewedTimestamp: $viewedTimestamp }) {
      id
      agreementId
      agreementType
      agreementVersion
      signedTimestamp
    }
  }
`;

export const ACKNOWLEDGE_CAPITAL_GROUP_MIGRATION_OVERRIDE = gql`
  mutation acknowledgeCapitalGroupMigrationOverride {
    acknowledgeCapitalGroupMigrationOverride
  }
`;
